<template>
    <div>
        <popup @closeEvent="closeEvent" v-if="showPopup" class="choose-dept">
            <div slot="popup-name" class="popup-name">{{ $t('staffManage.chooseDeptTitle') }}</div>
            <div slot="popup-con">
                <el-input :placeholder="$t('common.search')" v-model="filterText">
                </el-input>
                <el-tree key="chooseDept" ref="chooseDept" :filter-node-method="filterNode" 
                    :data="treeDataCopy"
                    :load="loadNode"
                    :lazy="isLazy"
                    @node-click="onNodeClick" :expand-on-click-node="false">
                    <span class="custom-tree-node" slot-scope="{node,data}">
                        <span class="custom-tree-node-left">
                            <!-- <span>
									<i class="arsenal_icon arsenalsitemap1"></i>
								</span> -->
                            <span v-if="data.dataType !== 'hasNext'" class="data-label">{{ data.label }}</span>
                                <span v-else :class="['el-tree-title-word-name', data.dataType == 'hasNext'?'loadMoreTree':'']">{{
                                data.label
                            }}</span>
                        </span>
                        <span v-show="data.checked">
                            <i class="el-icon-check"></i>
                        </span>
                    </span>
                </el-tree>

            </div>
            <div slot="dialog-footer">
                <el-button @click="closeEvent" plain round>{{ $t('common.cancel') }}</el-button>
                <el-button type="primary" @click="saveChooseDept" round>{{ $t('common.save') }}</el-button>
            </div>
        </popup>
    </div>
</template>

<script>
import Popup from '../../../../components/popup.vue';
import mixins from '../../upDownManage/mixins'
export default {
    mixins: [mixins],
    props: {
        treeData: {
            type: Array,
            default() {
                return []
            }
        },
        showPopup: {
            type: Boolean,
            default: false
        },
        isMultiple: {
            type: Boolean,
            default: true
        },
    },
    components: {
        Popup
    },
    data() {
        return {
            checkedDeptPopup: [],
            treeDataCopy: [],
            isMultiple: false,
            filterText: '',
            isLazy: false,
            newCurrentPage: 1,
            newPageSize: 10
        }
    },
    watch: {
        showPopup: {
            handler(n) {
                if (n) {
                    this.treeDataCopy = JSON.parse(JSON.stringify(this.treeData));
                    console.log(this.treeDataCopy, 'nnnn');
                    this.isLazy = this.treeDataCopy[0].lazy
                }
            },
            // immediate:true
        },
        filterText(val) {
            this.$refs.chooseDept.filter(val);
        }
    },
    methods: {
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
        // 关闭选择组织架构弹框
        closeEvent() {
            this.$emit('update:showPopup', false)
        },
        // 保存组织架构
        saveChooseDept() {
            this.checkedDeptPopup = [];
            this.judgeChildrens(this.treeDataCopy);
            this.$emit('checkedDept', this.checkedDeptPopup)
        },
        // 点击tree
        onNodeClick(data, node, el) {
            if(data.lazy) {
                this.getData(data.id, data, node, true).then(() =>{
                    this.treeDataCopy = this.handlerCheck(this.treeDataCopy, data, false);
                    this.$set(data, 'checked', true);
                })
            } else {
                this.treeDataCopy = this.handlerCheck(this.treeDataCopy, data, false);
                this.$set(data, 'checked', true);
            }
        },
        handlerCheck(treeData, data) {
            treeData.forEach((item, index) => {
                item.checked = false;
                if (item.children && item.children.length > 0) {
                    this.handlerCheck(item.children)
                }
            })
            return treeData
        },
        loadNode() {
            if (node.level === 0) {
                return resolve(this.treeDataCopy);
            }
            if (node.level > 1) {
                return resolve([]);
            } 
        },
        async getData(departId, data, node, isLoadMore) {
            console.log(1093, departId);
            let axiosDatas = [];
            let userId = localStorage.getItem("_uid");
            let url = ''
            if(departId) {
                url += "/api/department/corpDeptListLazy" +
                    "?departId=" +
                    departId +
                    "&userId=" +
                    userId +
                    "&corpId=" +
                    this.corpId + '&page=' + this.newCurrentPage + '&size=' + this.newPageSize
            } else {
                url += "/api/department/corpListLazy-v2" +
                    "?userId=" +
                    userId +
                    "&corpId=" +
                    this.corpId  + '&page=' + this.newCurrentPage + '&size=' + this.newPageSize;
            }
            url += '&needDepartTag=true'
                await this.$http.get(url).then((res) => {
                // let memberId = Number(this.memberInfo4Client.memberId);
                let ids = [];
                let datas = res.data.list.filter(item => item.type !== 0)
                datas.forEach((item, index) => {
                    item.rowIndex = index;

                });
                axiosDatas = datas
                console.log(res.data.list, axiosDatas);
                if (departId) {
                    if (res.data.hasNextPage){
                        let info = {
                            label: "加载更多",
                            dataType: 'hasNext',
                            id: departId + 'hasNext',
                            parentId: departId,
                            currentPage: res.data.nextPage?res.data.nextPage:1
                        }
                        axiosDatas = axiosDatas.concat([info])
                    }
                    axiosDatas.forEach(element => {
                        if(element.type === 0 || element.dataType === 'hasNext') {
                            element.leaf = true
                        }
                    })
                    if (isLoadMore) {
                        let flagFind = true;
                        let findParent = (list) => {
                            if (flagFind) {
                                list.forEach(item => {
                                    if (item.id == departId) {
                                        flagFind = false;
                                        if (item.children[item.children.length - 1].dataType == 'hasNext') {
                                            item.children.length = item.children.length - 1;
                                        }
                                        item.children = [...item.children, ...axiosDatas];
                                        item.showChildren = true;
                                    } else {
                                        findParent(item.children);
                                    }
                                })
                            }
                            
                        }
                        findParent(this.treeData);
                    } else {
                        data.children = [...data.children, ...axiosDatas];
                        data.showChildren = true;
                    }
                } else {
                }
            });
        },
    }
}
</script>

<style lang="less" scoped>
.choose-dept {
    .el-input {
        margin-bottom: 10px;
    }

    /deep/.el-tree {
        // .el-tree-node{
        // 	&.is-focusable{
        // 		background-color: #fff !important;
        // 	}
        // }
        .el-tree-node__content {
            height: 38px !important;
            background-color: #fff !important;

            &:hover {
                background-color: #f6f8fd !important;
            }

            .el-icon-check {
                font-size: 14px;
                font-weight: 600;
            }
        }
    }
}
</style>